import { observable, action } from 'mobx';
import firebaseService from '../FirebaseService';
import Utils from '../Utils';

class IssueStore{
    @observable Issues = [];
    @observable LoadingIssues = false;
    @observable IsAddingIssue = false;
    @observable ShowAddIssue = false;
    @observable AddIssueRequest = {
        IssueName: "",
        IssueDesc: "",
        IssuePriority: "",
        CreatedDate: "",
        IssueId:""        
    }
    @action UpdateAddIssueProperty(key,value){
        this.AddIssueRequest[key] = value;
    }
    @action GetIssues(){
        this.LoadingIssues = true;
        firebaseService.Issues()
                    .then((snapshot)=>{
                        this.Issues = [];
                        snapshot.forEach((childSnapshot)=>{
                            this.Issues.push(childSnapshot.val());
                        });
                        console.log(JSON.stringify(this.Issues));
                        
                    })
                    .catch((err)=>{  console.log(err);  Utils.Toast.Error("Unable to retrieve Issues"); })
                    .finally(()=>{ this.LoadingIssues = false;  });
    }
    @action AddIssue(){
        this.IsAddingIssue = true;
        firebaseService.AddIssue(this.AddIssueRequest)
        .then(()=>{
            this.ToggleAddIssueModal();
            this.GetIssues();

        })
        .catch((err)=>{  console.log(err);  Utils.Toast.Error("Unable to save Issue"); })
        .finally(()=>{ this.IsAddingIssue = false;  });
        
    }
    @action ToggleAddIssueModal(){
            this.ShowAddIssue = this.ShowAddIssue ? false : true;
    }
}
export default new IssueStore();


// WEBPACK FOOTER //
// ./src/stores/IssueStore.js